import { handleActions } from 'redux-actions';
import * as ACTION_TYPES from '../actions/actionTypes';

const initialState = {
    isLoading: false,
    bannerData: {}
};

export default handleActions({
    [ACTION_TYPES.IS_LOADING]: (state, action) => ({
        ...state,
        isLoading: action.payload
    })
}, initialState);
